import { useQuery } from "@tanstack/react-query";
import { projectDetailsApi } from "..";
import { queryClient } from "../../../shared/providers/QueryProvider";

export const useProject = (projectId: string | undefined) => {

    const { data, isFetching, isPending, isError, error } = useQuery({
        queryKey: ["project-details", projectId],
        queryFn: () => projectDetailsApi.fetchProjectDetails(projectId),
        enabled: !!projectId
    });

    return {
        projectData: data?.data,
        isPending, isFetching, isError,
        error,
        removeCache: () => {
            queryClient.removeQueries({ queryKey: ["project-details", projectId] });
        }
    };

};